import React from 'react';
import {Routes, Route} from 'react-router-dom';
import Home from './Sites/Home';
const PageRoutes = () => {
    return (
        <Routes>
            <Route index path = '/' element={<Home/>}/>
        </Routes>
    );
}
 
export default PageRoutes;